<template>
	<v-card>
		<v-card-title>结算</v-card-title>
		<v-card-text>
			<v-alert type="warning">注意现金支出应使用账户处理 - 建立相应的现金账户</v-alert>
			<div class="d-flex flex-row align-center">
				订单总金额：{{ order.totalamt }}元
				<price-level-selector @selected="onPriceLevelSelected">选择价格等级</price-level-selector>
				实付金额：{{ payamt }}元
			</div>
			<div class="d-flex flex-row align-center">
				<v-select :items="paytypes" v-model="form.type" :error-message="errors.type"></v-select>
				<shop-account-selector
					v-if="form.type == 'shopaccount'"
					@selected="onAccountSelected"
				></shop-account-selector>
				<span v-if="errors['ids']">{{ errors['ids'] }}</span>
				<v-text-field
					type="number"
					label="支付金额"
					v-model.number="form.amt"
					:error-message="errors.amt"
					style="max-width: 10rem"
				></v-text-field>
				元
				<v-btn color="primary" @click="addPayitem0">添加</v-btn>
			</div>
			<v-table v-if="payitems && payitems.length > 0" density="compact">
				<thead>
					<tr>
						<th>支付方式</th>
						<th>支付金额</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in payitems" :key="index">
						<td>{{ item.type }}({{ item.ids }})</td>
						<td>{{ item.amt }}</td>
						<td><v-btn @click="payitems.splice(index, 1)">删除</v-btn></td>
					</tr>
				</tbody>
			</v-table>
		</v-card-text>
		<slot name="actions" :payitems="payitems"></slot>
	</v-card>
</template>

<script>
import PriceLevelSelector from '../price/LevelSelector.vue'
import ShopAccountSelector from '../shop/AccountSelector.vue'

export default {
	components: { ShopAccountSelector, PriceLevelSelector },
	props: {
		order: { type: Object }
	},
	data() {
		return {
			form: {},
			errors: {},
			payitems: [],
			paytypes: [
				// { title: '现金', value: 'cash' },
				{ title: '账户', value: 'shopaccount' }
			]
		}
	},
	mounted() {},
	computed: {
		leftover() {
			//剩余金额
			return this.order.totalamt - this.payamt
		},
		payamt() {
			return this.payitems.reduce((sum, item) => {
				return sum + item.amt
			}, 0)
		}
	},
	watch: {
		'form.type': {
			handler(newVal) {
				this.form.ids = null
				this.form.amt = this.leftover
				this.errors['ids'] = null
			},
			immediate: true
		}
	},
	methods: {
		addPayitem0() {
			this.addPayitem(this.form)
			this.form = {}
		},
		addPayitem(form) {
			if (form.amt <= 0) {
				alert('支付金额必须大于0')
				return
			}
			if (form.type == 'shopaccount' && !form.ids) {
				alert('请选择账户')
				return
			}

			let ex = this.payitems.find((item, idx) => {
				return item.type == form.type && (form.ids ? item.id == form.ids : true)
			})
			if (ex) {
				let toamt = ex.amt + form.amt
				if (toamt > this.leftover) {
					alert('支付金额超过剩余金额')
					return
				}
				ex.amt = toamt
			} else {
				this.payitems.push({
					type: form.type,
					qty: form.qty, //如果积分的话会选择
					amt: form.amt,
					ids: form.ids + ''
				})
			}
		},
		onAccountSelected(ids, accounts) {
			this.form.ids = ids[0]
		},
		onPriceLevelSelected(ids, levels) {
			this.form.price_level = levels[0]
			//计算使用此价格等级产生的全部优惠金额（基于零售基础价） - 并放入payitems
			this.$api.order.getPriceLevelDiscount(
				this.order.id,
				ids[0],
				(r) => {
					this.addPayitem({
						type: 'pricelevel',
						amt: r,
						ids: ids[0] + '',
						qty: 1
					})
				},
				(e) => {
					alert(e.data)
				}
			)
		}
	}
}
</script>
